import { render, staticRenderFns } from "./matches_new.vue?vue&type=template&id=e410eb92&"
import script from "./matches_new.vue?vue&type=script&lang=js&"
export * from "./matches_new.vue?vue&type=script&lang=js&"
import style0 from "./matches_new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports